import { useEffect } from 'react';
import { APP_TITLE } from '../constants/app';

/**
 * Formats a page title consistently with the application name prefix.
 */
export function formatDocumentTitle(title?: string): string {
  if (!title) {
    return APP_TITLE;
  }
  return title.startsWith(APP_TITLE) ? title : `${APP_TITLE} | ${title}`;
}

/**
 * Updates document.title on mount or when title changes in SPA environments.
 */
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    const previousTitle = typeof document !== 'undefined' ? document.title : '';
    const nextTitle = formatDocumentTitle(title);
    if (typeof document !== 'undefined') {
      document.title = nextTitle;
    }

    return () => {
      if (typeof document !== 'undefined') {
        document.title = previousTitle || APP_TITLE;
      }
    };
  }, [title]);
}
